<template>
  <base-hover
    v-slot="{isHover}"
    class="item"
  >
    <div class="item__head">
      <base-text
        size="xs"
        medium
      >
        {{ title }}
      </base-text>
      <div class="date">
        <base-icon
          v-if="canDelete"
          icon="minus"
          class="delete__icon"
          :style="{opacity: (isHover)? 1: 0}"
          @click="$emit('delete') "
        />
        <base-text
          v-if="!isHover && canDelete || !canDelete"
          size="xs"
          light
          class="item__date"
        >
          {{ date | nicedate('relative') }}
        </base-text>
      </div>
    </div>
    <div
      class="item__message"
      v-html="message"
    />
    <div
      v-if="attachments && attachments.length > 0"
      class="pt-2"
    >
      <base-icon
        v-for="(item, index) in nonImageAttachments"
        :key="index"
        class="mr-2"
        :icon="getIcon(item)"
        @click="onAttachmentClicked(item)"
      />

      <div
        v-for="(item, index) in imageAttachments"
        :key="`image_attachment_${index}`"
      >
        <template v-if="item.content_type === 'image/gif'">
          <img
            class="image-attachment"
            :src="`${item.file_url}`"
            @click="onAttachmentClicked(item)"
          >
        </template>
        <template v-else>
          <img
            v-srcset
            class="image-attachment"
            :src="`${item.file_url}?w=220&h=200`"
            @click="onAttachmentClicked(item)"
          >
        </template>
      </div>
    </div>
  </base-hover>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    attachments: {
      type: Array,
      default: () => [],
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nonImageAttachments() {
      return this.attachments.filter((item) => item.content_type && !item.content_type.startsWith('image'));
    },
    imageAttachments() {
      return this.attachments.filter((item) => item.content_type?.startsWith('image'));
    },
  },
  methods: {
    getIcon(attachment) {
      // Derive from content type
      const CONTENT_TYPE_ICONS = {
        'image/png': 'file-jpg',
        'image/jpeg': 'file-jpg',
        'image/gif': 'file-gif',
        'application/pdf': 'file-pdf',
      };
      if (attachment.content_type in CONTENT_TYPE_ICONS) {
        return CONTENT_TYPE_ICONS[attachment.content_type];
      }
      // fallback
      return 'file';
    },
    onAttachmentClicked(attachment) {
      window.open(attachment.file_url, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep a {
  text-decoration: underline;
}
.item {
  background-color: $gray-light;
  border-radius: 3px;

  padding: 0.5rem;

  &+& {
    margin-top: 0.5rem;
  }
}

.item__head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.625rem;
  position: relative;
}

.item__message {
  color: #333333;
  line-height: 1rem;
  letter-spacing: -0.456px;
  font-family: $font-family-sans-serif-light;
  font-size: 0.75rem;
  &::v-deep strong{
    font-family: $font-family-sans-serif-medium;
    font-weight: normal;
  }
  &::v-deep p:last-child {
    margin-bottom: 0;
  }
}

.date {
  min-width: 60px;
}

.delete__icon {
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0.2s;
  cursor: pointer;
}
.image-attachment {
  display: block;
  max-width: 100%;
  max-height: 150px;
  width: auto;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  transition: 0.1s all;
  &:hover{
    opacity: 0.7;
  }
}
</style>
